import { TentTypeV1 } from '@camp67/model';
import { useParams } from '@remix-run/react';

import { TentPage } from '../page-factory/tent-page';
import { tentSummaryFromTentType } from '../pages/page-packages';
import { MetaFunction } from '@remix-run/cloudflare';
import { tents as tentsMap } from '../constants/tents';
import { tents } from '../locales/namespaces/home';

export const meta: MetaFunction = ({ params }) => {
  const tentType = tentDashCaseToTentType(params.tent as string);
  const tent = tentsMap[tentType];

  return [
    // Resolving to i18n in the tab does not seem to occur server side
    // temp fix by forcing to en
    { title: `${tents[tent.title as keyof typeof tents]} - camp67` },
    {
      name: 'description',
      content: tent.description,
    },
    {
      tagName: 'link',
      name: 'canonical',
      href: `https://camp67.com${tent.path}`,
    },
  ];
};

const tentDashCaseToTentType = (dashCaseTentType: string): TentTypeV1 => {
  switch (dashCaseTentType) {
    case 'dormitory-single': {
      return TentTypeV1.DORM_SINGLE;
    }
    case 'dormitory-bunk': {
      return TentTypeV1.DORM_BUNK;
    }
    case 'twin-cottage':
    case 'twin-room': {
      return TentTypeV1.TWIN_ROOM;
    }
    case 'private-cottage':
    case 'group-cottage':
    case 'private-group-cottage':
      return TentTypeV1.PRIVATE_GROUP_COTTAGE;
    // case 'premium-twin-cottage':
    // case 'premium-cottage':
    //   return TentTypeV1.PREMIUM_TWIN_COTTAGE;
    case 'family-cottage':
    case 'family-room': {
      return TentTypeV1.FAMILY_ROOM;
    }
    // case 'family-cottage-plus':
    // case 'family-room-plus': {
    //   return TentTypeV1.FAMILY_ROOM_PLUS;
    // }
    default: {
      return TentTypeV1.TWIN_ROOM;
    }
  }
};

export default function PackagesTentPage() {
  const tentType = tentDashCaseToTentType(useParams().tent as string);

  return <TentPage tentType={tentType} summary={tentSummaryFromTentType(tentType)} />;
}
